"use strict";
/**
 * Pagination helpers shared by the backend repositories and the clients.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePagination = normalizePagination;
exports.buildPaginationMeta = buildPaginationMeta;
exports.paginated = paginated;
const shared_types_1 = require("@restor/shared-types");
/**
 * Clamps client-supplied paging into a safe range.
 *
 * An unbounded `limit` is a denial-of-service vector on an orders table, so the
 * cap is enforced server-side rather than trusted from the query string.
 */
function normalizePagination(query = {}) {
    const page = Math.max(1, Math.floor(Number(query.page) || 1));
    const requested = Math.floor(Number(query.limit) || shared_types_1.DEFAULT_PAGE_SIZE);
    const limit = Math.min(shared_types_1.MAX_PAGE_SIZE, Math.max(1, requested));
    return { page, limit, skip: (page - 1) * limit, take: limit };
}
function buildPaginationMeta(total, { page, limit }) {
    const totalPages = limit > 0 ? Math.ceil(total / limit) : 0;
    return {
        page,
        limit,
        total,
        totalPages,
        hasNext: page < totalPages,
        hasPrev: page > 1,
    };
}
function paginated(items, total, pagination) {
    return { items, pagination: buildPaginationMeta(total, pagination) };
}
//# sourceMappingURL=pagination.js.map